module.exports = __webpack_public_path__ + "img/img6.4b3e5964.png";